export function gql(strings, ...args) {
  let str = "";
  strings.forEach((string, i) => {
    str += string + (args[i] || "");
  });
  return str;
}
export const ResourcesPartsFragmentDoc = gql`
    fragment ResourcesParts on Resources {
  __typename
  ... on ResourcesAdvisory {
    templateType
    published
    publishDate
    advisoryId
    cveId
    title
    subtitle
    cvssScore
    categories {
      __typename
      category {
        ... on Categories {
          __typename
          ... on CategoriesCategory {
            title
            categorySlug
            subtitle
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            seo {
              __typename
              title
              description
              keywords
              noindex
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    tags {
      __typename
      tag {
        ... on Tags {
          __typename
          ... on TagsTag {
            title
            tagSlug
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    affectedVendors {
      __typename
      name
    }
    affectedProducts {
      __typename
      name
    }
    description
    vulnerabilityInformation
    potentialImpact
    details {
      __typename
      title
      content
    }
    _githubSource
    _githubSyncDate
    _readOnly
    headerCta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    resourceSeo {
      __typename
      seoTitle
      seoDescription
      keywords
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourcesArticle {
    templateType
    published
    publishDate
    title
    description
    headerBackgroundImage
    authors {
      __typename
      ... on ResourcesArticleAuthorsTeamMemberAuthor {
        slug
        cachedName
        cachedRole
      }
      ... on ResourcesArticleAuthorsTeamAuthor {
        team
      }
      ... on ResourcesArticleAuthorsCustomAuthor {
        name
        url
      }
    }
    author
    categories {
      __typename
      category {
        ... on Categories {
          __typename
          ... on CategoriesCategory {
            title
            categorySlug
            subtitle
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            seo {
              __typename
              title
              description
              keywords
              noindex
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    tags {
      __typename
      tag {
        ... on Tags {
          __typename
          ... on TagsTag {
            title
            tagSlug
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    resourceSeo {
      __typename
      seoTitle
      seoDescription
      keywords
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
    content
  }
  ... on ResourcesBlog {
    templateType
    published
    publishDate
    title
    description
    headerBackgroundImage
    authors {
      __typename
      ... on ResourcesBlogAuthorsTeamMemberAuthor {
        slug
        cachedName
        cachedRole
      }
      ... on ResourcesBlogAuthorsTeamAuthor {
        team
      }
      ... on ResourcesBlogAuthorsCustomAuthor {
        name
        url
      }
    }
    author
    categories {
      __typename
      category {
        ... on Categories {
          __typename
          ... on CategoriesCategory {
            title
            categorySlug
            subtitle
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            seo {
              __typename
              title
              description
              keywords
              noindex
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    tags {
      __typename
      tag {
        ... on Tags {
          __typename
          ... on TagsTag {
            title
            tagSlug
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    resourceSeo {
      __typename
      seoTitle
      seoDescription
      keywords
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
    content
  }
  ... on ResourcesStudy {
    templateType
    published
    publishDate
    title
    description
    categories {
      __typename
      category {
        ... on Categories {
          __typename
          ... on CategoriesCategory {
            title
            categorySlug
            subtitle
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            seo {
              __typename
              title
              description
              keywords
              noindex
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    tags {
      __typename
      tag {
        ... on Tags {
          __typename
          ... on TagsTag {
            title
            tagSlug
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    header {
      __typename
      logo
      title
      graphic
      file
    }
    sections {
      __typename
      ... on ResourcesStudySectionsOpening {
        description
        video {
          ... on Resources {
            __typename
            ... on ResourcesAdvisory {
              templateType
              published
              publishDate
              advisoryId
              cveId
              title
              subtitle
              cvssScore
              categories {
                __typename
              }
              tags {
                __typename
              }
              affectedVendors {
                __typename
                name
              }
              affectedProducts {
                __typename
                name
              }
              description
              vulnerabilityInformation
              potentialImpact
              details {
                __typename
                title
                content
              }
              _githubSource
              _githubSyncDate
              _readOnly
              headerCta {
                __typename
                localNote
                title
                description
                buttons {
                  __typename
                  _breadcrumb
                  label
                  link
                }
              }
              cta {
                __typename
                localNote
                title
                description
                buttons {
                  __typename
                  _breadcrumb
                  label
                  link
                }
              }
              resourceSeo {
                __typename
                seoTitle
                seoDescription
                keywords
                ogType
                image
                breadcrumbs {
                  __typename
                  label
                  url
                }
              }
            }
            ... on ResourcesArticle {
              templateType
              published
              publishDate
              title
              description
              headerBackgroundImage
              authors {
                __typename
                ... on ResourcesArticleAuthorsTeamMemberAuthor {
                  slug
                  cachedName
                  cachedRole
                }
                ... on ResourcesArticleAuthorsTeamAuthor {
                  team
                }
                ... on ResourcesArticleAuthorsCustomAuthor {
                  name
                  url
                }
              }
              author
              categories {
                __typename
              }
              tags {
                __typename
              }
              resourceSeo {
                __typename
                seoTitle
                seoDescription
                keywords
                ogType
                image
                breadcrumbs {
                  __typename
                  label
                  url
                }
              }
              content
            }
            ... on ResourcesBlog {
              templateType
              published
              publishDate
              title
              description
              headerBackgroundImage
              authors {
                __typename
                ... on ResourcesBlogAuthorsTeamMemberAuthor {
                  slug
                  cachedName
                  cachedRole
                }
                ... on ResourcesBlogAuthorsTeamAuthor {
                  team
                }
                ... on ResourcesBlogAuthorsCustomAuthor {
                  name
                  url
                }
              }
              author
              categories {
                __typename
              }
              tags {
                __typename
              }
              resourceSeo {
                __typename
                seoTitle
                seoDescription
                keywords
                ogType
                image
                breadcrumbs {
                  __typename
                  label
                  url
                }
              }
              content
            }
            ... on ResourcesStudy {
              templateType
              published
              publishDate
              title
              description
              categories {
                __typename
              }
              tags {
                __typename
              }
              header {
                __typename
                logo
                title
                graphic
                file
              }
              sections {
                __typename
                ... on ResourcesStudySectionsOpening {
                  description
                  quote
                  author
                  authorRole
                }
                ... on ResourcesStudySectionsChallenge {
                  title
                  subtitle
                  challenges {
                    __typename
                    title
                    description
                  }
                }
                ... on ResourcesStudySectionsSolution {
                  title
                  subtitle
                  solutions {
                    __typename
                    icon
                    title
                    description
                  }
                }
                ... on ResourcesStudySectionsResults {
                  title
                  subtitle
                  results {
                    __typename
                    icon
                    title
                    description
                  }
                }
                ... on ResourcesStudySectionsConclusion {
                  title
                  description
                }
              }
              resourceSeo {
                __typename
                seoTitle
                seoDescription
                keywords
                ogType
                image
                breadcrumbs {
                  __typename
                  label
                  url
                }
              }
            }
            ... on ResourcesNews {
              templateType
              published
              publishDate
              title
              description
              authors {
                __typename
                ... on ResourcesNewsAuthorsTeamMemberAuthor {
                  slug
                  cachedName
                  cachedRole
                }
                ... on ResourcesNewsAuthorsTeamAuthor {
                  team
                }
                ... on ResourcesNewsAuthorsCustomAuthor {
                  name
                  url
                }
              }
              author
              categories {
                __typename
              }
              tags {
                __typename
              }
              resourceSeo {
                __typename
                seoTitle
                seoDescription
                keywords
                ogType
                image
                breadcrumbs {
                  __typename
                  label
                  url
                }
              }
              content
            }
            ... on ResourcesPatent {
              templateType
              published
              publishDate
              title
              description
              categories {
                __typename
              }
              tags {
                __typename
              }
              resourceSeo {
                __typename
                seoTitle
                seoDescription
                keywords
                ogType
                image
                breadcrumbs {
                  __typename
                  label
                  url
                }
              }
              content
            }
            ... on ResourcesPress {
              templateType
              published
              title
              publishDate
              description
              categories {
                __typename
              }
              tags {
                __typename
              }
              externalUrl
              resourceSeo {
                __typename
                seoTitle
                seoDescription
                keywords
                ogType
                image
                breadcrumbs {
                  __typename
                  label
                  url
                }
              }
            }
            ... on ResourcesReport {
              templateType
              published
              publishDate
              title
              description
              categories {
                __typename
              }
              tags {
                __typename
              }
              externalUrl
              uploadReport
              resourceSeo {
                __typename
                seoTitle
                seoDescription
                keywords
                ogType
                image
                breadcrumbs {
                  __typename
                  label
                  url
                }
              }
            }
            ... on ResourcesTool {
              templateType
              published
              publishDate
              title
              description
              categories {
                __typename
              }
              tags {
                __typename
              }
              externalUrl
              logo
              hasDetailPage
              header {
                __typename
                title
                tagline
                buttons {
                  __typename
                  label
                  link
                }
              }
              sections {
                __typename
                ... on ResourcesToolSectionsToolIntro {
                  title
                  subtitle
                  problemItems {
                    __typename
                    title
                    description
                  }
                  solutionItems {
                    __typename
                    title
                    description
                  }
                }
                ... on ResourcesToolSectionsToolCapabilities {
                  title
                  subtitle
                  capabilities {
                    __typename
                    title
                    description
                    tag
                  }
                }
                ... on ResourcesToolSectionsToolSteps {
                  title
                  subtitle
                  steps {
                    __typename
                    label
                    title
                    description
                  }
                }
                ... on ResourcesToolSectionsToolUseCases {
                  title
                  subtitle
                  useCases {
                    __typename
                    icon
                    title
                    description
                  }
                }
                ... on ResourcesToolSectionsToolResources {
                  title
                  resources {
                    __typename
                  }
                }
              }
              cta {
                __typename
                localNote
                title
                description
                buttons {
                  __typename
                  _breadcrumb
                  label
                  link
                }
              }
              resourceSeo {
                __typename
                seoTitle
                seoDescription
                keywords
                ogType
                image
                breadcrumbs {
                  __typename
                  label
                  url
                }
              }
            }
            ... on ResourcesVideo {
              templateType
              published
              publishDate
              title
              description
              categories {
                __typename
              }
              tags {
                __typename
              }
              resourceSeo {
                __typename
                seoTitle
                seoDescription
                keywords
                ogType
                image
                breadcrumbs {
                  __typename
                  label
                  url
                }
              }
              url
            }
          }
          ... on Document {
            _sys {
              filename
              basename
              hasReferences
              breadcrumbs
              path
              relativePath
              extension
            }
            id
          }
        }
        quote
        author
        authorRole
      }
      ... on ResourcesStudySectionsChallenge {
        title
        subtitle
        challenges {
          __typename
          title
          description
        }
      }
      ... on ResourcesStudySectionsSolution {
        title
        subtitle
        solutions {
          __typename
          icon
          title
          description
        }
      }
      ... on ResourcesStudySectionsResults {
        title
        subtitle
        results {
          __typename
          icon
          title
          description
        }
      }
      ... on ResourcesStudySectionsConclusion {
        title
        description
      }
    }
    resourceSeo {
      __typename
      seoTitle
      seoDescription
      keywords
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourcesNews {
    templateType
    published
    publishDate
    title
    description
    authors {
      __typename
      ... on ResourcesNewsAuthorsTeamMemberAuthor {
        slug
        cachedName
        cachedRole
      }
      ... on ResourcesNewsAuthorsTeamAuthor {
        team
      }
      ... on ResourcesNewsAuthorsCustomAuthor {
        name
        url
      }
    }
    author
    categories {
      __typename
      category {
        ... on Categories {
          __typename
          ... on CategoriesCategory {
            title
            categorySlug
            subtitle
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            seo {
              __typename
              title
              description
              keywords
              noindex
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    tags {
      __typename
      tag {
        ... on Tags {
          __typename
          ... on TagsTag {
            title
            tagSlug
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    resourceSeo {
      __typename
      seoTitle
      seoDescription
      keywords
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
    content
  }
  ... on ResourcesPatent {
    templateType
    published
    publishDate
    title
    description
    categories {
      __typename
      category {
        ... on Categories {
          __typename
          ... on CategoriesCategory {
            title
            categorySlug
            subtitle
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            seo {
              __typename
              title
              description
              keywords
              noindex
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    tags {
      __typename
      tag {
        ... on Tags {
          __typename
          ... on TagsTag {
            title
            tagSlug
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    resourceSeo {
      __typename
      seoTitle
      seoDescription
      keywords
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
    content
  }
  ... on ResourcesPress {
    templateType
    published
    title
    publishDate
    description
    categories {
      __typename
      category {
        ... on Categories {
          __typename
          ... on CategoriesCategory {
            title
            categorySlug
            subtitle
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            seo {
              __typename
              title
              description
              keywords
              noindex
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    tags {
      __typename
      tag {
        ... on Tags {
          __typename
          ... on TagsTag {
            title
            tagSlug
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    externalUrl
    resourceSeo {
      __typename
      seoTitle
      seoDescription
      keywords
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourcesReport {
    templateType
    published
    publishDate
    title
    description
    categories {
      __typename
      category {
        ... on Categories {
          __typename
          ... on CategoriesCategory {
            title
            categorySlug
            subtitle
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            seo {
              __typename
              title
              description
              keywords
              noindex
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    tags {
      __typename
      tag {
        ... on Tags {
          __typename
          ... on TagsTag {
            title
            tagSlug
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    externalUrl
    uploadReport
    resourceSeo {
      __typename
      seoTitle
      seoDescription
      keywords
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourcesTool {
    templateType
    published
    publishDate
    title
    description
    categories {
      __typename
      category {
        ... on Categories {
          __typename
          ... on CategoriesCategory {
            title
            categorySlug
            subtitle
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            seo {
              __typename
              title
              description
              keywords
              noindex
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    tags {
      __typename
      tag {
        ... on Tags {
          __typename
          ... on TagsTag {
            title
            tagSlug
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    externalUrl
    logo
    hasDetailPage
    header {
      __typename
      title
      tagline
      buttons {
        __typename
        label
        link
      }
    }
    sections {
      __typename
      ... on ResourcesToolSectionsToolIntro {
        title
        subtitle
        problemItems {
          __typename
          title
          description
        }
        solutionItems {
          __typename
          title
          description
        }
      }
      ... on ResourcesToolSectionsToolCapabilities {
        title
        subtitle
        capabilities {
          __typename
          title
          description
          tag
        }
      }
      ... on ResourcesToolSectionsToolSteps {
        title
        subtitle
        steps {
          __typename
          label
          title
          description
        }
      }
      ... on ResourcesToolSectionsToolUseCases {
        title
        subtitle
        useCases {
          __typename
          icon
          title
          description
        }
      }
      ... on ResourcesToolSectionsToolResources {
        title
        resources {
          __typename
          resource {
            ... on Resources {
              __typename
              ... on ResourcesAdvisory {
                templateType
                published
                publishDate
                advisoryId
                cveId
                title
                subtitle
                cvssScore
                categories {
                  __typename
                }
                tags {
                  __typename
                }
                affectedVendors {
                  __typename
                  name
                }
                affectedProducts {
                  __typename
                  name
                }
                description
                vulnerabilityInformation
                potentialImpact
                details {
                  __typename
                  title
                  content
                }
                _githubSource
                _githubSyncDate
                _readOnly
                headerCta {
                  __typename
                  localNote
                  title
                  description
                  buttons {
                    __typename
                    _breadcrumb
                    label
                    link
                  }
                }
                cta {
                  __typename
                  localNote
                  title
                  description
                  buttons {
                    __typename
                    _breadcrumb
                    label
                    link
                  }
                }
                resourceSeo {
                  __typename
                  seoTitle
                  seoDescription
                  keywords
                  ogType
                  image
                  breadcrumbs {
                    __typename
                    label
                    url
                  }
                }
              }
              ... on ResourcesArticle {
                templateType
                published
                publishDate
                title
                description
                headerBackgroundImage
                authors {
                  __typename
                  ... on ResourcesArticleAuthorsTeamMemberAuthor {
                    slug
                    cachedName
                    cachedRole
                  }
                  ... on ResourcesArticleAuthorsTeamAuthor {
                    team
                  }
                  ... on ResourcesArticleAuthorsCustomAuthor {
                    name
                    url
                  }
                }
                author
                categories {
                  __typename
                }
                tags {
                  __typename
                }
                resourceSeo {
                  __typename
                  seoTitle
                  seoDescription
                  keywords
                  ogType
                  image
                  breadcrumbs {
                    __typename
                    label
                    url
                  }
                }
                content
              }
              ... on ResourcesBlog {
                templateType
                published
                publishDate
                title
                description
                headerBackgroundImage
                authors {
                  __typename
                  ... on ResourcesBlogAuthorsTeamMemberAuthor {
                    slug
                    cachedName
                    cachedRole
                  }
                  ... on ResourcesBlogAuthorsTeamAuthor {
                    team
                  }
                  ... on ResourcesBlogAuthorsCustomAuthor {
                    name
                    url
                  }
                }
                author
                categories {
                  __typename
                }
                tags {
                  __typename
                }
                resourceSeo {
                  __typename
                  seoTitle
                  seoDescription
                  keywords
                  ogType
                  image
                  breadcrumbs {
                    __typename
                    label
                    url
                  }
                }
                content
              }
              ... on ResourcesStudy {
                templateType
                published
                publishDate
                title
                description
                categories {
                  __typename
                }
                tags {
                  __typename
                }
                header {
                  __typename
                  logo
                  title
                  graphic
                  file
                }
                sections {
                  __typename
                  ... on ResourcesStudySectionsOpening {
                    description
                    quote
                    author
                    authorRole
                  }
                  ... on ResourcesStudySectionsChallenge {
                    title
                    subtitle
                    challenges {
                      __typename
                      title
                      description
                    }
                  }
                  ... on ResourcesStudySectionsSolution {
                    title
                    subtitle
                    solutions {
                      __typename
                      icon
                      title
                      description
                    }
                  }
                  ... on ResourcesStudySectionsResults {
                    title
                    subtitle
                    results {
                      __typename
                      icon
                      title
                      description
                    }
                  }
                  ... on ResourcesStudySectionsConclusion {
                    title
                    description
                  }
                }
                resourceSeo {
                  __typename
                  seoTitle
                  seoDescription
                  keywords
                  ogType
                  image
                  breadcrumbs {
                    __typename
                    label
                    url
                  }
                }
              }
              ... on ResourcesNews {
                templateType
                published
                publishDate
                title
                description
                authors {
                  __typename
                  ... on ResourcesNewsAuthorsTeamMemberAuthor {
                    slug
                    cachedName
                    cachedRole
                  }
                  ... on ResourcesNewsAuthorsTeamAuthor {
                    team
                  }
                  ... on ResourcesNewsAuthorsCustomAuthor {
                    name
                    url
                  }
                }
                author
                categories {
                  __typename
                }
                tags {
                  __typename
                }
                resourceSeo {
                  __typename
                  seoTitle
                  seoDescription
                  keywords
                  ogType
                  image
                  breadcrumbs {
                    __typename
                    label
                    url
                  }
                }
                content
              }
              ... on ResourcesPatent {
                templateType
                published
                publishDate
                title
                description
                categories {
                  __typename
                }
                tags {
                  __typename
                }
                resourceSeo {
                  __typename
                  seoTitle
                  seoDescription
                  keywords
                  ogType
                  image
                  breadcrumbs {
                    __typename
                    label
                    url
                  }
                }
                content
              }
              ... on ResourcesPress {
                templateType
                published
                title
                publishDate
                description
                categories {
                  __typename
                }
                tags {
                  __typename
                }
                externalUrl
                resourceSeo {
                  __typename
                  seoTitle
                  seoDescription
                  keywords
                  ogType
                  image
                  breadcrumbs {
                    __typename
                    label
                    url
                  }
                }
              }
              ... on ResourcesReport {
                templateType
                published
                publishDate
                title
                description
                categories {
                  __typename
                }
                tags {
                  __typename
                }
                externalUrl
                uploadReport
                resourceSeo {
                  __typename
                  seoTitle
                  seoDescription
                  keywords
                  ogType
                  image
                  breadcrumbs {
                    __typename
                    label
                    url
                  }
                }
              }
              ... on ResourcesTool {
                templateType
                published
                publishDate
                title
                description
                categories {
                  __typename
                }
                tags {
                  __typename
                }
                externalUrl
                logo
                hasDetailPage
                header {
                  __typename
                  title
                  tagline
                  buttons {
                    __typename
                    label
                    link
                  }
                }
                sections {
                  __typename
                  ... on ResourcesToolSectionsToolIntro {
                    title
                    subtitle
                    problemItems {
                      __typename
                      title
                      description
                    }
                    solutionItems {
                      __typename
                      title
                      description
                    }
                  }
                  ... on ResourcesToolSectionsToolCapabilities {
                    title
                    subtitle
                    capabilities {
                      __typename
                      title
                      description
                      tag
                    }
                  }
                  ... on ResourcesToolSectionsToolSteps {
                    title
                    subtitle
                    steps {
                      __typename
                      label
                      title
                      description
                    }
                  }
                  ... on ResourcesToolSectionsToolUseCases {
                    title
                    subtitle
                    useCases {
                      __typename
                      icon
                      title
                      description
                    }
                  }
                  ... on ResourcesToolSectionsToolResources {
                    title
                    resources {
                      __typename
                    }
                  }
                }
                cta {
                  __typename
                  localNote
                  title
                  description
                  buttons {
                    __typename
                    _breadcrumb
                    label
                    link
                  }
                }
                resourceSeo {
                  __typename
                  seoTitle
                  seoDescription
                  keywords
                  ogType
                  image
                  breadcrumbs {
                    __typename
                    label
                    url
                  }
                }
              }
              ... on ResourcesVideo {
                templateType
                published
                publishDate
                title
                description
                categories {
                  __typename
                }
                tags {
                  __typename
                }
                resourceSeo {
                  __typename
                  seoTitle
                  seoDescription
                  keywords
                  ogType
                  image
                  breadcrumbs {
                    __typename
                    label
                    url
                  }
                }
                url
              }
            }
            ... on Document {
              _sys {
                filename
                basename
                hasReferences
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
        }
      }
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    resourceSeo {
      __typename
      seoTitle
      seoDescription
      keywords
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourcesVideo {
    templateType
    published
    publishDate
    title
    description
    categories {
      __typename
      category {
        ... on Categories {
          __typename
          ... on CategoriesCategory {
            title
            categorySlug
            subtitle
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            seo {
              __typename
              title
              description
              keywords
              noindex
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    tags {
      __typename
      tag {
        ... on Tags {
          __typename
          ... on TagsTag {
            title
            tagSlug
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    resourceSeo {
      __typename
      seoTitle
      seoDescription
      keywords
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
    url
  }
}
    `;
export const ResourceLandingPagesPartsFragmentDoc = gql`
    fragment ResourceLandingPagesParts on ResourceLandingPages {
  __typename
  ... on ResourceLandingPagesAllResourcesLanding {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourceLandingPagesAdvisoryLanding {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    stats {
      __typename
      statsCards {
        __typename
        value
        automatic
        label
      }
    }
    quickLinksSection {
      __typename
      quickLinks {
        __typename
        title
        description
        buttons {
          __typename
          label
          link
        }
        copyEmailAddress
        pgpPublicKey
        pgpPublicKeyFilename
        keyCopy
      }
    }
    researchSection {
      __typename
      title
      subtitle
      description
      button {
        __typename
        label
        link
      }
      links {
        __typename
        label
        url
        icon
      }
    }
    cta {
      __typename
      localNote
      title
      description
      disclaimer
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourceLandingPagesArticleLanding {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    includeLogos
    featuredResources {
      __typename
      resource {
        ... on Resources {
          __typename
          ... on ResourcesAdvisory {
            templateType
            published
            publishDate
            advisoryId
            cveId
            title
            subtitle
            cvssScore
            categories {
              __typename
            }
            tags {
              __typename
            }
            affectedVendors {
              __typename
              name
            }
            affectedProducts {
              __typename
              name
            }
            description
            vulnerabilityInformation
            potentialImpact
            details {
              __typename
              title
              content
            }
            _githubSource
            _githubSyncDate
            _readOnly
            headerCta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesArticle {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesArticleAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesArticleAuthorsTeamAuthor {
                team
              }
              ... on ResourcesArticleAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesBlog {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesBlogAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesBlogAuthorsTeamAuthor {
                team
              }
              ... on ResourcesBlogAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesStudy {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            header {
              __typename
              logo
              title
              graphic
              file
            }
            sections {
              __typename
              ... on ResourcesStudySectionsOpening {
                description
                quote
                author
                authorRole
              }
              ... on ResourcesStudySectionsChallenge {
                title
                subtitle
                challenges {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsSolution {
                title
                subtitle
                solutions {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsResults {
                title
                subtitle
                results {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsConclusion {
                title
                description
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesNews {
            templateType
            published
            publishDate
            title
            description
            authors {
              __typename
              ... on ResourcesNewsAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesNewsAuthorsTeamAuthor {
                team
              }
              ... on ResourcesNewsAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPatent {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPress {
            templateType
            published
            title
            publishDate
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesReport {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            uploadReport
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesTool {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            logo
            hasDetailPage
            header {
              __typename
              title
              tagline
              buttons {
                __typename
                label
                link
              }
            }
            sections {
              __typename
              ... on ResourcesToolSectionsToolIntro {
                title
                subtitle
                problemItems {
                  __typename
                  title
                  description
                }
                solutionItems {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolCapabilities {
                title
                subtitle
                capabilities {
                  __typename
                  title
                  description
                  tag
                }
              }
              ... on ResourcesToolSectionsToolSteps {
                title
                subtitle
                steps {
                  __typename
                  label
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolUseCases {
                title
                subtitle
                useCases {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolResources {
                title
                resources {
                  __typename
                }
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesVideo {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            url
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourceLandingPagesBlogLanding {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    includeLogos
    featuredResources {
      __typename
      resource {
        ... on Resources {
          __typename
          ... on ResourcesAdvisory {
            templateType
            published
            publishDate
            advisoryId
            cveId
            title
            subtitle
            cvssScore
            categories {
              __typename
            }
            tags {
              __typename
            }
            affectedVendors {
              __typename
              name
            }
            affectedProducts {
              __typename
              name
            }
            description
            vulnerabilityInformation
            potentialImpact
            details {
              __typename
              title
              content
            }
            _githubSource
            _githubSyncDate
            _readOnly
            headerCta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesArticle {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesArticleAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesArticleAuthorsTeamAuthor {
                team
              }
              ... on ResourcesArticleAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesBlog {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesBlogAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesBlogAuthorsTeamAuthor {
                team
              }
              ... on ResourcesBlogAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesStudy {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            header {
              __typename
              logo
              title
              graphic
              file
            }
            sections {
              __typename
              ... on ResourcesStudySectionsOpening {
                description
                quote
                author
                authorRole
              }
              ... on ResourcesStudySectionsChallenge {
                title
                subtitle
                challenges {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsSolution {
                title
                subtitle
                solutions {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsResults {
                title
                subtitle
                results {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsConclusion {
                title
                description
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesNews {
            templateType
            published
            publishDate
            title
            description
            authors {
              __typename
              ... on ResourcesNewsAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesNewsAuthorsTeamAuthor {
                team
              }
              ... on ResourcesNewsAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPatent {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPress {
            templateType
            published
            title
            publishDate
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesReport {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            uploadReport
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesTool {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            logo
            hasDetailPage
            header {
              __typename
              title
              tagline
              buttons {
                __typename
                label
                link
              }
            }
            sections {
              __typename
              ... on ResourcesToolSectionsToolIntro {
                title
                subtitle
                problemItems {
                  __typename
                  title
                  description
                }
                solutionItems {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolCapabilities {
                title
                subtitle
                capabilities {
                  __typename
                  title
                  description
                  tag
                }
              }
              ... on ResourcesToolSectionsToolSteps {
                title
                subtitle
                steps {
                  __typename
                  label
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolUseCases {
                title
                subtitle
                useCases {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolResources {
                title
                resources {
                  __typename
                }
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesVideo {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            url
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourceLandingPagesStudyLanding {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    includeLogos
    featuredResources {
      __typename
      resource {
        ... on Resources {
          __typename
          ... on ResourcesAdvisory {
            templateType
            published
            publishDate
            advisoryId
            cveId
            title
            subtitle
            cvssScore
            categories {
              __typename
            }
            tags {
              __typename
            }
            affectedVendors {
              __typename
              name
            }
            affectedProducts {
              __typename
              name
            }
            description
            vulnerabilityInformation
            potentialImpact
            details {
              __typename
              title
              content
            }
            _githubSource
            _githubSyncDate
            _readOnly
            headerCta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesArticle {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesArticleAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesArticleAuthorsTeamAuthor {
                team
              }
              ... on ResourcesArticleAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesBlog {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesBlogAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesBlogAuthorsTeamAuthor {
                team
              }
              ... on ResourcesBlogAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesStudy {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            header {
              __typename
              logo
              title
              graphic
              file
            }
            sections {
              __typename
              ... on ResourcesStudySectionsOpening {
                description
                quote
                author
                authorRole
              }
              ... on ResourcesStudySectionsChallenge {
                title
                subtitle
                challenges {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsSolution {
                title
                subtitle
                solutions {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsResults {
                title
                subtitle
                results {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsConclusion {
                title
                description
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesNews {
            templateType
            published
            publishDate
            title
            description
            authors {
              __typename
              ... on ResourcesNewsAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesNewsAuthorsTeamAuthor {
                team
              }
              ... on ResourcesNewsAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPatent {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPress {
            templateType
            published
            title
            publishDate
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesReport {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            uploadReport
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesTool {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            logo
            hasDetailPage
            header {
              __typename
              title
              tagline
              buttons {
                __typename
                label
                link
              }
            }
            sections {
              __typename
              ... on ResourcesToolSectionsToolIntro {
                title
                subtitle
                problemItems {
                  __typename
                  title
                  description
                }
                solutionItems {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolCapabilities {
                title
                subtitle
                capabilities {
                  __typename
                  title
                  description
                  tag
                }
              }
              ... on ResourcesToolSectionsToolSteps {
                title
                subtitle
                steps {
                  __typename
                  label
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolUseCases {
                title
                subtitle
                useCases {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolResources {
                title
                resources {
                  __typename
                }
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesVideo {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            url
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourceLandingPagesNewsLanding {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    includeLogos
    featuredResources {
      __typename
      resource {
        ... on Resources {
          __typename
          ... on ResourcesAdvisory {
            templateType
            published
            publishDate
            advisoryId
            cveId
            title
            subtitle
            cvssScore
            categories {
              __typename
            }
            tags {
              __typename
            }
            affectedVendors {
              __typename
              name
            }
            affectedProducts {
              __typename
              name
            }
            description
            vulnerabilityInformation
            potentialImpact
            details {
              __typename
              title
              content
            }
            _githubSource
            _githubSyncDate
            _readOnly
            headerCta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesArticle {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesArticleAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesArticleAuthorsTeamAuthor {
                team
              }
              ... on ResourcesArticleAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesBlog {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesBlogAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesBlogAuthorsTeamAuthor {
                team
              }
              ... on ResourcesBlogAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesStudy {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            header {
              __typename
              logo
              title
              graphic
              file
            }
            sections {
              __typename
              ... on ResourcesStudySectionsOpening {
                description
                quote
                author
                authorRole
              }
              ... on ResourcesStudySectionsChallenge {
                title
                subtitle
                challenges {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsSolution {
                title
                subtitle
                solutions {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsResults {
                title
                subtitle
                results {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsConclusion {
                title
                description
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesNews {
            templateType
            published
            publishDate
            title
            description
            authors {
              __typename
              ... on ResourcesNewsAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesNewsAuthorsTeamAuthor {
                team
              }
              ... on ResourcesNewsAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPatent {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPress {
            templateType
            published
            title
            publishDate
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesReport {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            uploadReport
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesTool {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            logo
            hasDetailPage
            header {
              __typename
              title
              tagline
              buttons {
                __typename
                label
                link
              }
            }
            sections {
              __typename
              ... on ResourcesToolSectionsToolIntro {
                title
                subtitle
                problemItems {
                  __typename
                  title
                  description
                }
                solutionItems {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolCapabilities {
                title
                subtitle
                capabilities {
                  __typename
                  title
                  description
                  tag
                }
              }
              ... on ResourcesToolSectionsToolSteps {
                title
                subtitle
                steps {
                  __typename
                  label
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolUseCases {
                title
                subtitle
                useCases {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolResources {
                title
                resources {
                  __typename
                }
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesVideo {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            url
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourceLandingPagesPressLanding {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    includeLogos
    featuredResources {
      __typename
      resource {
        ... on Resources {
          __typename
          ... on ResourcesAdvisory {
            templateType
            published
            publishDate
            advisoryId
            cveId
            title
            subtitle
            cvssScore
            categories {
              __typename
            }
            tags {
              __typename
            }
            affectedVendors {
              __typename
              name
            }
            affectedProducts {
              __typename
              name
            }
            description
            vulnerabilityInformation
            potentialImpact
            details {
              __typename
              title
              content
            }
            _githubSource
            _githubSyncDate
            _readOnly
            headerCta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesArticle {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesArticleAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesArticleAuthorsTeamAuthor {
                team
              }
              ... on ResourcesArticleAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesBlog {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesBlogAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesBlogAuthorsTeamAuthor {
                team
              }
              ... on ResourcesBlogAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesStudy {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            header {
              __typename
              logo
              title
              graphic
              file
            }
            sections {
              __typename
              ... on ResourcesStudySectionsOpening {
                description
                quote
                author
                authorRole
              }
              ... on ResourcesStudySectionsChallenge {
                title
                subtitle
                challenges {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsSolution {
                title
                subtitle
                solutions {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsResults {
                title
                subtitle
                results {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsConclusion {
                title
                description
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesNews {
            templateType
            published
            publishDate
            title
            description
            authors {
              __typename
              ... on ResourcesNewsAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesNewsAuthorsTeamAuthor {
                team
              }
              ... on ResourcesNewsAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPatent {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPress {
            templateType
            published
            title
            publishDate
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesReport {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            uploadReport
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesTool {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            logo
            hasDetailPage
            header {
              __typename
              title
              tagline
              buttons {
                __typename
                label
                link
              }
            }
            sections {
              __typename
              ... on ResourcesToolSectionsToolIntro {
                title
                subtitle
                problemItems {
                  __typename
                  title
                  description
                }
                solutionItems {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolCapabilities {
                title
                subtitle
                capabilities {
                  __typename
                  title
                  description
                  tag
                }
              }
              ... on ResourcesToolSectionsToolSteps {
                title
                subtitle
                steps {
                  __typename
                  label
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolUseCases {
                title
                subtitle
                useCases {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolResources {
                title
                resources {
                  __typename
                }
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesVideo {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            url
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourceLandingPagesReportLanding {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    includeLogos
    featuredResources {
      __typename
      resource {
        ... on Resources {
          __typename
          ... on ResourcesAdvisory {
            templateType
            published
            publishDate
            advisoryId
            cveId
            title
            subtitle
            cvssScore
            categories {
              __typename
            }
            tags {
              __typename
            }
            affectedVendors {
              __typename
              name
            }
            affectedProducts {
              __typename
              name
            }
            description
            vulnerabilityInformation
            potentialImpact
            details {
              __typename
              title
              content
            }
            _githubSource
            _githubSyncDate
            _readOnly
            headerCta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesArticle {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesArticleAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesArticleAuthorsTeamAuthor {
                team
              }
              ... on ResourcesArticleAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesBlog {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesBlogAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesBlogAuthorsTeamAuthor {
                team
              }
              ... on ResourcesBlogAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesStudy {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            header {
              __typename
              logo
              title
              graphic
              file
            }
            sections {
              __typename
              ... on ResourcesStudySectionsOpening {
                description
                quote
                author
                authorRole
              }
              ... on ResourcesStudySectionsChallenge {
                title
                subtitle
                challenges {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsSolution {
                title
                subtitle
                solutions {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsResults {
                title
                subtitle
                results {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsConclusion {
                title
                description
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesNews {
            templateType
            published
            publishDate
            title
            description
            authors {
              __typename
              ... on ResourcesNewsAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesNewsAuthorsTeamAuthor {
                team
              }
              ... on ResourcesNewsAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPatent {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPress {
            templateType
            published
            title
            publishDate
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesReport {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            uploadReport
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesTool {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            logo
            hasDetailPage
            header {
              __typename
              title
              tagline
              buttons {
                __typename
                label
                link
              }
            }
            sections {
              __typename
              ... on ResourcesToolSectionsToolIntro {
                title
                subtitle
                problemItems {
                  __typename
                  title
                  description
                }
                solutionItems {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolCapabilities {
                title
                subtitle
                capabilities {
                  __typename
                  title
                  description
                  tag
                }
              }
              ... on ResourcesToolSectionsToolSteps {
                title
                subtitle
                steps {
                  __typename
                  label
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolUseCases {
                title
                subtitle
                useCases {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolResources {
                title
                resources {
                  __typename
                }
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesVideo {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            url
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourceLandingPagesToolLanding {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    includeLogos
    featuredResources {
      __typename
      resource {
        ... on Resources {
          __typename
          ... on ResourcesAdvisory {
            templateType
            published
            publishDate
            advisoryId
            cveId
            title
            subtitle
            cvssScore
            categories {
              __typename
            }
            tags {
              __typename
            }
            affectedVendors {
              __typename
              name
            }
            affectedProducts {
              __typename
              name
            }
            description
            vulnerabilityInformation
            potentialImpact
            details {
              __typename
              title
              content
            }
            _githubSource
            _githubSyncDate
            _readOnly
            headerCta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesArticle {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesArticleAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesArticleAuthorsTeamAuthor {
                team
              }
              ... on ResourcesArticleAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesBlog {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesBlogAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesBlogAuthorsTeamAuthor {
                team
              }
              ... on ResourcesBlogAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesStudy {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            header {
              __typename
              logo
              title
              graphic
              file
            }
            sections {
              __typename
              ... on ResourcesStudySectionsOpening {
                description
                quote
                author
                authorRole
              }
              ... on ResourcesStudySectionsChallenge {
                title
                subtitle
                challenges {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsSolution {
                title
                subtitle
                solutions {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsResults {
                title
                subtitle
                results {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsConclusion {
                title
                description
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesNews {
            templateType
            published
            publishDate
            title
            description
            authors {
              __typename
              ... on ResourcesNewsAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesNewsAuthorsTeamAuthor {
                team
              }
              ... on ResourcesNewsAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPatent {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPress {
            templateType
            published
            title
            publishDate
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesReport {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            uploadReport
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesTool {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            logo
            hasDetailPage
            header {
              __typename
              title
              tagline
              buttons {
                __typename
                label
                link
              }
            }
            sections {
              __typename
              ... on ResourcesToolSectionsToolIntro {
                title
                subtitle
                problemItems {
                  __typename
                  title
                  description
                }
                solutionItems {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolCapabilities {
                title
                subtitle
                capabilities {
                  __typename
                  title
                  description
                  tag
                }
              }
              ... on ResourcesToolSectionsToolSteps {
                title
                subtitle
                steps {
                  __typename
                  label
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolUseCases {
                title
                subtitle
                useCases {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolResources {
                title
                resources {
                  __typename
                }
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesVideo {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            url
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourceLandingPagesPatentLanding {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    includeLogos
    featuredResources {
      __typename
      resource {
        ... on Resources {
          __typename
          ... on ResourcesAdvisory {
            templateType
            published
            publishDate
            advisoryId
            cveId
            title
            subtitle
            cvssScore
            categories {
              __typename
            }
            tags {
              __typename
            }
            affectedVendors {
              __typename
              name
            }
            affectedProducts {
              __typename
              name
            }
            description
            vulnerabilityInformation
            potentialImpact
            details {
              __typename
              title
              content
            }
            _githubSource
            _githubSyncDate
            _readOnly
            headerCta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesArticle {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesArticleAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesArticleAuthorsTeamAuthor {
                team
              }
              ... on ResourcesArticleAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesBlog {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesBlogAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesBlogAuthorsTeamAuthor {
                team
              }
              ... on ResourcesBlogAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesStudy {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            header {
              __typename
              logo
              title
              graphic
              file
            }
            sections {
              __typename
              ... on ResourcesStudySectionsOpening {
                description
                quote
                author
                authorRole
              }
              ... on ResourcesStudySectionsChallenge {
                title
                subtitle
                challenges {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsSolution {
                title
                subtitle
                solutions {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsResults {
                title
                subtitle
                results {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsConclusion {
                title
                description
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesNews {
            templateType
            published
            publishDate
            title
            description
            authors {
              __typename
              ... on ResourcesNewsAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesNewsAuthorsTeamAuthor {
                team
              }
              ... on ResourcesNewsAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPatent {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPress {
            templateType
            published
            title
            publishDate
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesReport {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            uploadReport
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesTool {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            logo
            hasDetailPage
            header {
              __typename
              title
              tagline
              buttons {
                __typename
                label
                link
              }
            }
            sections {
              __typename
              ... on ResourcesToolSectionsToolIntro {
                title
                subtitle
                problemItems {
                  __typename
                  title
                  description
                }
                solutionItems {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolCapabilities {
                title
                subtitle
                capabilities {
                  __typename
                  title
                  description
                  tag
                }
              }
              ... on ResourcesToolSectionsToolSteps {
                title
                subtitle
                steps {
                  __typename
                  label
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolUseCases {
                title
                subtitle
                useCases {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolResources {
                title
                resources {
                  __typename
                }
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesVideo {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            url
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResourceLandingPagesVideoLanding {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    includeLogos
    featuredResources {
      __typename
      resource {
        ... on Resources {
          __typename
          ... on ResourcesAdvisory {
            templateType
            published
            publishDate
            advisoryId
            cveId
            title
            subtitle
            cvssScore
            categories {
              __typename
            }
            tags {
              __typename
            }
            affectedVendors {
              __typename
              name
            }
            affectedProducts {
              __typename
              name
            }
            description
            vulnerabilityInformation
            potentialImpact
            details {
              __typename
              title
              content
            }
            _githubSource
            _githubSyncDate
            _readOnly
            headerCta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesArticle {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesArticleAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesArticleAuthorsTeamAuthor {
                team
              }
              ... on ResourcesArticleAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesBlog {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesBlogAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesBlogAuthorsTeamAuthor {
                team
              }
              ... on ResourcesBlogAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesStudy {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            header {
              __typename
              logo
              title
              graphic
              file
            }
            sections {
              __typename
              ... on ResourcesStudySectionsOpening {
                description
                quote
                author
                authorRole
              }
              ... on ResourcesStudySectionsChallenge {
                title
                subtitle
                challenges {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsSolution {
                title
                subtitle
                solutions {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsResults {
                title
                subtitle
                results {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsConclusion {
                title
                description
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesNews {
            templateType
            published
            publishDate
            title
            description
            authors {
              __typename
              ... on ResourcesNewsAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesNewsAuthorsTeamAuthor {
                team
              }
              ... on ResourcesNewsAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPatent {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPress {
            templateType
            published
            title
            publishDate
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesReport {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            uploadReport
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesTool {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            logo
            hasDetailPage
            header {
              __typename
              title
              tagline
              buttons {
                __typename
                label
                link
              }
            }
            sections {
              __typename
              ... on ResourcesToolSectionsToolIntro {
                title
                subtitle
                problemItems {
                  __typename
                  title
                  description
                }
                solutionItems {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolCapabilities {
                title
                subtitle
                capabilities {
                  __typename
                  title
                  description
                  tag
                }
              }
              ... on ResourcesToolSectionsToolSteps {
                title
                subtitle
                steps {
                  __typename
                  label
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolUseCases {
                title
                subtitle
                useCases {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolResources {
                title
                resources {
                  __typename
                }
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesVideo {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            url
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
}
    `;
export const CategoriesPartsFragmentDoc = gql`
    fragment CategoriesParts on Categories {
  __typename
  ... on CategoriesCategory {
    title
    categorySlug
    subtitle
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
}
    `;
export const TagsPartsFragmentDoc = gql`
    fragment TagsParts on Tags {
  __typename
  ... on TagsTag {
    title
    tagSlug
  }
}
    `;
export const SolutionIndexPagesPartsFragmentDoc = gql`
    fragment SolutionIndexPagesParts on SolutionIndexPages {
  __typename
  ... on SolutionIndexPagesUseCaseIndex {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on SolutionIndexPagesIndustryIndex {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on SolutionIndexPagesRoleIndex {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
}
    `;
export const SolutionsPartsFragmentDoc = gql`
    fragment SolutionsParts on Solutions {
  __typename
  ... on SolutionsUseCase {
    templateType
    header {
      __typename
      name
      icon
      title
      subtitle
      video
      image
    }
    intro {
      __typename
      graphic
      title
      description
    }
    sections {
      __typename
      ... on SolutionsUseCaseSectionsKeyFeatures {
        title
        subtitle
        features {
          __typename
          icon
          title
          description
        }
      }
      ... on SolutionsUseCaseSectionsBenefits {
        title
        subtitle
        benefits {
          __typename
          icon
          title
          description
        }
      }
      ... on SolutionsUseCaseSectionsProof {
        title
        subtitle
      }
      ... on SolutionsUseCaseSectionsConclusion {
        title
        description
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on SolutionsIndustry {
    templateType
    header {
      __typename
      name
      icon
      title
      subtitle
      video
      image
    }
    intro {
      __typename
      graphic
      title
      description
    }
    sections {
      __typename
      ... on SolutionsIndustrySectionsKeyFeatures {
        title
        subtitle
        features {
          __typename
          icon
          title
          description
        }
      }
      ... on SolutionsIndustrySectionsBenefits {
        title
        subtitle
        benefits {
          __typename
          icon
          title
          description
        }
      }
      ... on SolutionsIndustrySectionsProof {
        title
        subtitle
      }
      ... on SolutionsIndustrySectionsConclusion {
        title
        description
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on SolutionsRole {
    templateType
    header {
      __typename
      name
      icon
      title
      subtitle
      video
      image
    }
    intro {
      __typename
      graphic
      title
      description
    }
    sections {
      __typename
      ... on SolutionsRoleSectionsKeyFeatures {
        title
        subtitle
        features {
          __typename
          icon
          title
          description
        }
      }
      ... on SolutionsRoleSectionsBenefits {
        title
        subtitle
        benefits {
          __typename
          icon
          title
          description
        }
      }
      ... on SolutionsRoleSectionsProof {
        title
        subtitle
      }
      ... on SolutionsRoleSectionsConclusion {
        title
        description
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
}
    `;
export const ResearchPagesPartsFragmentDoc = gql`
    fragment ResearchPagesParts on ResearchPages {
  __typename
  ... on ResearchPagesAllResearch {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    advisoriesCta {
      __typename
      title
      description
      button {
        __typename
        label
        link
      }
    }
    researchTeam {
      __typename
      teamNote
      title
    }
    toolsCta {
      __typename
      title
      description
      tools {
        __typename
        title
        description
        button {
          __typename
          label
          link
        }
      }
    }
    reportsCta {
      __typename
      title
      description
      instruction
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResearchPagesResearchLanding {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    resourceTypes
    resourceCategories
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
  ... on ResearchPagesDisclosurePolicy {
    header {
      __typename
      pretitle
      title
      subtitle
      button {
        __typename
        label
        link
      }
    }
    faqs {
      __typename
      title
      faqs {
        __typename
        question
        answer
      }
      showFaqs
    }
    cta {
      __typename
      localNote
      title
      description
      buttons {
        __typename
        _breadcrumb
        label
        link
      }
    }
    seo {
      __typename
      title
      description
      keywords
      noindex
      ogType
      image
      breadcrumbs {
        __typename
        label
        url
      }
    }
  }
}
    `;
export const ReportsPartsFragmentDoc = gql`
    fragment ReportsParts on Reports {
  __typename
  title
  tag {
    ... on Tags {
      __typename
      ... on TagsTag {
        title
        tagSlug
      }
    }
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
  }
  header {
    __typename
    pretitle
    title
    subtitle
    report {
      ... on Resources {
        __typename
        ... on ResourcesAdvisory {
          templateType
          published
          publishDate
          advisoryId
          cveId
          title
          subtitle
          cvssScore
          categories {
            __typename
          }
          tags {
            __typename
          }
          affectedVendors {
            __typename
            name
          }
          affectedProducts {
            __typename
            name
          }
          description
          vulnerabilityInformation
          potentialImpact
          details {
            __typename
            title
            content
          }
          _githubSource
          _githubSyncDate
          _readOnly
          headerCta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          cta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesArticle {
          templateType
          published
          publishDate
          title
          description
          headerBackgroundImage
          authors {
            __typename
            ... on ResourcesArticleAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesArticleAuthorsTeamAuthor {
              team
            }
            ... on ResourcesArticleAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesBlog {
          templateType
          published
          publishDate
          title
          description
          headerBackgroundImage
          authors {
            __typename
            ... on ResourcesBlogAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesBlogAuthorsTeamAuthor {
              team
            }
            ... on ResourcesBlogAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesStudy {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          header {
            __typename
            logo
            title
            graphic
            file
          }
          sections {
            __typename
            ... on ResourcesStudySectionsOpening {
              description
              quote
              author
              authorRole
            }
            ... on ResourcesStudySectionsChallenge {
              title
              subtitle
              challenges {
                __typename
                title
                description
              }
            }
            ... on ResourcesStudySectionsSolution {
              title
              subtitle
              solutions {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesStudySectionsResults {
              title
              subtitle
              results {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesStudySectionsConclusion {
              title
              description
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesNews {
          templateType
          published
          publishDate
          title
          description
          authors {
            __typename
            ... on ResourcesNewsAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesNewsAuthorsTeamAuthor {
              team
            }
            ... on ResourcesNewsAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesPatent {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesPress {
          templateType
          published
          title
          publishDate
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesReport {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          uploadReport
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesTool {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          logo
          hasDetailPage
          header {
            __typename
            title
            tagline
            buttons {
              __typename
              label
              link
            }
          }
          sections {
            __typename
            ... on ResourcesToolSectionsToolIntro {
              title
              subtitle
              problemItems {
                __typename
                title
                description
              }
              solutionItems {
                __typename
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolCapabilities {
              title
              subtitle
              capabilities {
                __typename
                title
                description
                tag
              }
            }
            ... on ResourcesToolSectionsToolSteps {
              title
              subtitle
              steps {
                __typename
                label
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolUseCases {
              title
              subtitle
              useCases {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolResources {
              title
              resources {
                __typename
              }
            }
          }
          cta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesVideo {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          url
        }
      }
      ... on Document {
        _sys {
          filename
          basename
          hasReferences
          breadcrumbs
          path
          relativePath
          extension
        }
        id
      }
    }
    video {
      ... on Resources {
        __typename
        ... on ResourcesAdvisory {
          templateType
          published
          publishDate
          advisoryId
          cveId
          title
          subtitle
          cvssScore
          categories {
            __typename
          }
          tags {
            __typename
          }
          affectedVendors {
            __typename
            name
          }
          affectedProducts {
            __typename
            name
          }
          description
          vulnerabilityInformation
          potentialImpact
          details {
            __typename
            title
            content
          }
          _githubSource
          _githubSyncDate
          _readOnly
          headerCta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          cta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesArticle {
          templateType
          published
          publishDate
          title
          description
          headerBackgroundImage
          authors {
            __typename
            ... on ResourcesArticleAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesArticleAuthorsTeamAuthor {
              team
            }
            ... on ResourcesArticleAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesBlog {
          templateType
          published
          publishDate
          title
          description
          headerBackgroundImage
          authors {
            __typename
            ... on ResourcesBlogAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesBlogAuthorsTeamAuthor {
              team
            }
            ... on ResourcesBlogAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesStudy {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          header {
            __typename
            logo
            title
            graphic
            file
          }
          sections {
            __typename
            ... on ResourcesStudySectionsOpening {
              description
              quote
              author
              authorRole
            }
            ... on ResourcesStudySectionsChallenge {
              title
              subtitle
              challenges {
                __typename
                title
                description
              }
            }
            ... on ResourcesStudySectionsSolution {
              title
              subtitle
              solutions {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesStudySectionsResults {
              title
              subtitle
              results {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesStudySectionsConclusion {
              title
              description
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesNews {
          templateType
          published
          publishDate
          title
          description
          authors {
            __typename
            ... on ResourcesNewsAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesNewsAuthorsTeamAuthor {
              team
            }
            ... on ResourcesNewsAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesPatent {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesPress {
          templateType
          published
          title
          publishDate
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesReport {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          uploadReport
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesTool {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          logo
          hasDetailPage
          header {
            __typename
            title
            tagline
            buttons {
              __typename
              label
              link
            }
          }
          sections {
            __typename
            ... on ResourcesToolSectionsToolIntro {
              title
              subtitle
              problemItems {
                __typename
                title
                description
              }
              solutionItems {
                __typename
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolCapabilities {
              title
              subtitle
              capabilities {
                __typename
                title
                description
                tag
              }
            }
            ... on ResourcesToolSectionsToolSteps {
              title
              subtitle
              steps {
                __typename
                label
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolUseCases {
              title
              subtitle
              useCases {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolResources {
              title
              resources {
                __typename
              }
            }
          }
          cta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesVideo {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          url
        }
      }
      ... on Document {
        _sys {
          filename
          basename
          hasReferences
          breadcrumbs
          path
          relativePath
          extension
        }
        id
      }
    }
  }
  proofOfConcept {
    __typename
    title
    description
    featuredVideos {
      __typename
      video {
        ... on Resources {
          __typename
          ... on ResourcesAdvisory {
            templateType
            published
            publishDate
            advisoryId
            cveId
            title
            subtitle
            cvssScore
            categories {
              __typename
            }
            tags {
              __typename
            }
            affectedVendors {
              __typename
              name
            }
            affectedProducts {
              __typename
              name
            }
            description
            vulnerabilityInformation
            potentialImpact
            details {
              __typename
              title
              content
            }
            _githubSource
            _githubSyncDate
            _readOnly
            headerCta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesArticle {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesArticleAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesArticleAuthorsTeamAuthor {
                team
              }
              ... on ResourcesArticleAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesBlog {
            templateType
            published
            publishDate
            title
            description
            headerBackgroundImage
            authors {
              __typename
              ... on ResourcesBlogAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesBlogAuthorsTeamAuthor {
                team
              }
              ... on ResourcesBlogAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesStudy {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            header {
              __typename
              logo
              title
              graphic
              file
            }
            sections {
              __typename
              ... on ResourcesStudySectionsOpening {
                description
                quote
                author
                authorRole
              }
              ... on ResourcesStudySectionsChallenge {
                title
                subtitle
                challenges {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsSolution {
                title
                subtitle
                solutions {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsResults {
                title
                subtitle
                results {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesStudySectionsConclusion {
                title
                description
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesNews {
            templateType
            published
            publishDate
            title
            description
            authors {
              __typename
              ... on ResourcesNewsAuthorsTeamMemberAuthor {
                slug
                cachedName
                cachedRole
              }
              ... on ResourcesNewsAuthorsTeamAuthor {
                team
              }
              ... on ResourcesNewsAuthorsCustomAuthor {
                name
                url
              }
            }
            author
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPatent {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            content
          }
          ... on ResourcesPress {
            templateType
            published
            title
            publishDate
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesReport {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            uploadReport
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesTool {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            externalUrl
            logo
            hasDetailPage
            header {
              __typename
              title
              tagline
              buttons {
                __typename
                label
                link
              }
            }
            sections {
              __typename
              ... on ResourcesToolSectionsToolIntro {
                title
                subtitle
                problemItems {
                  __typename
                  title
                  description
                }
                solutionItems {
                  __typename
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolCapabilities {
                title
                subtitle
                capabilities {
                  __typename
                  title
                  description
                  tag
                }
              }
              ... on ResourcesToolSectionsToolSteps {
                title
                subtitle
                steps {
                  __typename
                  label
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolUseCases {
                title
                subtitle
                useCases {
                  __typename
                  icon
                  title
                  description
                }
              }
              ... on ResourcesToolSectionsToolResources {
                title
                resources {
                  __typename
                }
              }
            }
            cta {
              __typename
              localNote
              title
              description
              buttons {
                __typename
                _breadcrumb
                label
                link
              }
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
          }
          ... on ResourcesVideo {
            templateType
            published
            publishDate
            title
            description
            categories {
              __typename
            }
            tags {
              __typename
            }
            resourceSeo {
              __typename
              seoTitle
              seoDescription
              keywords
              ogType
              image
              breadcrumbs {
                __typename
                label
                url
              }
            }
            url
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
    }
  }
  toolCTA {
    __typename
    title
    description
    tool {
      ... on Resources {
        __typename
        ... on ResourcesAdvisory {
          templateType
          published
          publishDate
          advisoryId
          cveId
          title
          subtitle
          cvssScore
          categories {
            __typename
          }
          tags {
            __typename
          }
          affectedVendors {
            __typename
            name
          }
          affectedProducts {
            __typename
            name
          }
          description
          vulnerabilityInformation
          potentialImpact
          details {
            __typename
            title
            content
          }
          _githubSource
          _githubSyncDate
          _readOnly
          headerCta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          cta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesArticle {
          templateType
          published
          publishDate
          title
          description
          headerBackgroundImage
          authors {
            __typename
            ... on ResourcesArticleAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesArticleAuthorsTeamAuthor {
              team
            }
            ... on ResourcesArticleAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesBlog {
          templateType
          published
          publishDate
          title
          description
          headerBackgroundImage
          authors {
            __typename
            ... on ResourcesBlogAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesBlogAuthorsTeamAuthor {
              team
            }
            ... on ResourcesBlogAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesStudy {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          header {
            __typename
            logo
            title
            graphic
            file
          }
          sections {
            __typename
            ... on ResourcesStudySectionsOpening {
              description
              quote
              author
              authorRole
            }
            ... on ResourcesStudySectionsChallenge {
              title
              subtitle
              challenges {
                __typename
                title
                description
              }
            }
            ... on ResourcesStudySectionsSolution {
              title
              subtitle
              solutions {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesStudySectionsResults {
              title
              subtitle
              results {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesStudySectionsConclusion {
              title
              description
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesNews {
          templateType
          published
          publishDate
          title
          description
          authors {
            __typename
            ... on ResourcesNewsAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesNewsAuthorsTeamAuthor {
              team
            }
            ... on ResourcesNewsAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesPatent {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesPress {
          templateType
          published
          title
          publishDate
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesReport {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          uploadReport
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesTool {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          logo
          hasDetailPage
          header {
            __typename
            title
            tagline
            buttons {
              __typename
              label
              link
            }
          }
          sections {
            __typename
            ... on ResourcesToolSectionsToolIntro {
              title
              subtitle
              problemItems {
                __typename
                title
                description
              }
              solutionItems {
                __typename
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolCapabilities {
              title
              subtitle
              capabilities {
                __typename
                title
                description
                tag
              }
            }
            ... on ResourcesToolSectionsToolSteps {
              title
              subtitle
              steps {
                __typename
                label
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolUseCases {
              title
              subtitle
              useCases {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolResources {
              title
              resources {
                __typename
              }
            }
          }
          cta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesVideo {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          url
        }
      }
      ... on Document {
        _sys {
          filename
          basename
          hasReferences
          breadcrumbs
          path
          relativePath
          extension
        }
        id
      }
    }
  }
  cta {
    __typename
    localNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
    noindex
    ogType
    image
    breadcrumbs {
      __typename
      label
      url
    }
  }
}
    `;
export const FormLandingPagesPartsFragmentDoc = gql`
    fragment FormLandingPagesParts on FormLandingPages {
  __typename
  title
  header {
    __typename
    pretitle
    title
    subtitle
    benefits {
      __typename
      title
      description
    }
  }
  formSection {
    __typename
    formSize
    meetingEmbedUrl
  }
  videoSection {
    __typename
    title
    description
    video {
      ... on Resources {
        __typename
        ... on ResourcesAdvisory {
          templateType
          published
          publishDate
          advisoryId
          cveId
          title
          subtitle
          cvssScore
          categories {
            __typename
          }
          tags {
            __typename
          }
          affectedVendors {
            __typename
            name
          }
          affectedProducts {
            __typename
            name
          }
          description
          vulnerabilityInformation
          potentialImpact
          details {
            __typename
            title
            content
          }
          _githubSource
          _githubSyncDate
          _readOnly
          headerCta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          cta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesArticle {
          templateType
          published
          publishDate
          title
          description
          headerBackgroundImage
          authors {
            __typename
            ... on ResourcesArticleAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesArticleAuthorsTeamAuthor {
              team
            }
            ... on ResourcesArticleAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesBlog {
          templateType
          published
          publishDate
          title
          description
          headerBackgroundImage
          authors {
            __typename
            ... on ResourcesBlogAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesBlogAuthorsTeamAuthor {
              team
            }
            ... on ResourcesBlogAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesStudy {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          header {
            __typename
            logo
            title
            graphic
            file
          }
          sections {
            __typename
            ... on ResourcesStudySectionsOpening {
              description
              quote
              author
              authorRole
            }
            ... on ResourcesStudySectionsChallenge {
              title
              subtitle
              challenges {
                __typename
                title
                description
              }
            }
            ... on ResourcesStudySectionsSolution {
              title
              subtitle
              solutions {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesStudySectionsResults {
              title
              subtitle
              results {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesStudySectionsConclusion {
              title
              description
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesNews {
          templateType
          published
          publishDate
          title
          description
          authors {
            __typename
            ... on ResourcesNewsAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesNewsAuthorsTeamAuthor {
              team
            }
            ... on ResourcesNewsAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesPatent {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesPress {
          templateType
          published
          title
          publishDate
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesReport {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          uploadReport
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesTool {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          logo
          hasDetailPage
          header {
            __typename
            title
            tagline
            buttons {
              __typename
              label
              link
            }
          }
          sections {
            __typename
            ... on ResourcesToolSectionsToolIntro {
              title
              subtitle
              problemItems {
                __typename
                title
                description
              }
              solutionItems {
                __typename
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolCapabilities {
              title
              subtitle
              capabilities {
                __typename
                title
                description
                tag
              }
            }
            ... on ResourcesToolSectionsToolSteps {
              title
              subtitle
              steps {
                __typename
                label
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolUseCases {
              title
              subtitle
              useCases {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolResources {
              title
              resources {
                __typename
              }
            }
          }
          cta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesVideo {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          url
        }
      }
      ... on Document {
        _sys {
          filename
          basename
          hasReferences
          breadcrumbs
          path
          relativePath
          extension
        }
        id
      }
    }
  }
  cta {
    __typename
    localNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
    noindex
    ogType
    image
    breadcrumbs {
      __typename
      label
      url
    }
  }
}
    `;
export const HomePartsFragmentDoc = gql`
    fragment HomeParts on Home {
  __typename
  header {
    __typename
    title
    subtitle
    button {
      __typename
      label
      link
    }
    video
    image
  }
  aboutUs {
    __typename
    title
    description
    tagline
    button {
      __typename
      label
      link
    }
  }
  features {
    __typename
    features {
      __typename
      title
      description
      link
      image
    }
  }
  cta {
    __typename
    localNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  latestContent {
    __typename
    title
    sources {
      __typename
      resourceType
      categories
    }
  }
  cta2 {
    __typename
    localNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
    noindex
    ogType
    image
    breadcrumbs {
      __typename
      label
      url
    }
  }
}
    `;
export const FeaturesPartsFragmentDoc = gql`
    fragment FeaturesParts on Features {
  __typename
  header {
    __typename
    pretitle
    title
    subtitle
    button {
      __typename
      label
      link
    }
  }
  sections {
    __typename
    title
    features {
      __typename
      title
      description
      image
    }
  }
  faqs {
    __typename
    title
    faqs {
      __typename
      question
      answer
    }
    showFaqs
  }
  cta {
    __typename
    localNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
    noindex
    ogType
    image
    breadcrumbs {
      __typename
      label
      url
    }
  }
}
    `;
export const PackagesPartsFragmentDoc = gql`
    fragment PackagesParts on Packages {
  __typename
  header {
    __typename
    pretitle
    title
    subtitle
    button {
      __typename
      label
      link
    }
  }
  plans {
    __typename
    id
    name
    description
    button {
      __typename
      label
      link
    }
  }
  sections {
    __typename
    title
    learnMoreLink
    features {
      __typename
      name
      enabledPlans
      tooltip
    }
  }
  customers {
    __typename
    localNote
    title
    subtitle
  }
  faqs {
    __typename
    title
    faqs {
      __typename
      question
      answer
    }
    showFaqs
  }
  cta {
    __typename
    localNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
    noindex
    ogType
    image
    breadcrumbs {
      __typename
      label
      url
    }
  }
}
    `;
export const AboutPartsFragmentDoc = gql`
    fragment AboutParts on About {
  __typename
  header {
    __typename
    pretitle
    title
    subtitle
    button {
      __typename
      label
      link
    }
  }
  video {
    __typename
    videoResource {
      ... on Resources {
        __typename
        ... on ResourcesAdvisory {
          templateType
          published
          publishDate
          advisoryId
          cveId
          title
          subtitle
          cvssScore
          categories {
            __typename
          }
          tags {
            __typename
          }
          affectedVendors {
            __typename
            name
          }
          affectedProducts {
            __typename
            name
          }
          description
          vulnerabilityInformation
          potentialImpact
          details {
            __typename
            title
            content
          }
          _githubSource
          _githubSyncDate
          _readOnly
          headerCta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          cta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesArticle {
          templateType
          published
          publishDate
          title
          description
          headerBackgroundImage
          authors {
            __typename
            ... on ResourcesArticleAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesArticleAuthorsTeamAuthor {
              team
            }
            ... on ResourcesArticleAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesBlog {
          templateType
          published
          publishDate
          title
          description
          headerBackgroundImage
          authors {
            __typename
            ... on ResourcesBlogAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesBlogAuthorsTeamAuthor {
              team
            }
            ... on ResourcesBlogAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesStudy {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          header {
            __typename
            logo
            title
            graphic
            file
          }
          sections {
            __typename
            ... on ResourcesStudySectionsOpening {
              description
              quote
              author
              authorRole
            }
            ... on ResourcesStudySectionsChallenge {
              title
              subtitle
              challenges {
                __typename
                title
                description
              }
            }
            ... on ResourcesStudySectionsSolution {
              title
              subtitle
              solutions {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesStudySectionsResults {
              title
              subtitle
              results {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesStudySectionsConclusion {
              title
              description
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesNews {
          templateType
          published
          publishDate
          title
          description
          authors {
            __typename
            ... on ResourcesNewsAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesNewsAuthorsTeamAuthor {
              team
            }
            ... on ResourcesNewsAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesPatent {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesPress {
          templateType
          published
          title
          publishDate
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesReport {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          uploadReport
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesTool {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          logo
          hasDetailPage
          header {
            __typename
            title
            tagline
            buttons {
              __typename
              label
              link
            }
          }
          sections {
            __typename
            ... on ResourcesToolSectionsToolIntro {
              title
              subtitle
              problemItems {
                __typename
                title
                description
              }
              solutionItems {
                __typename
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolCapabilities {
              title
              subtitle
              capabilities {
                __typename
                title
                description
                tag
              }
            }
            ... on ResourcesToolSectionsToolSteps {
              title
              subtitle
              steps {
                __typename
                label
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolUseCases {
              title
              subtitle
              useCases {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolResources {
              title
              resources {
                __typename
              }
            }
          }
          cta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesVideo {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          url
        }
      }
      ... on Document {
        _sys {
          filename
          basename
          hasReferences
          breadcrumbs
          path
          relativePath
          extension
        }
        id
      }
    }
  }
  missionStatement {
    __typename
    title
    subtitle
  }
  teamIntro {
    __typename
    title
    subtitle
    description
    images {
      __typename
      image
      alt
    }
  }
  quote {
    __typename
    image
    quote
    name
    role
  }
  heads {
    __typename
    title
    subtitle
    teamMember {
      __typename
      name
      slug
      role
      isResearcher
      description
      image
      socials {
        __typename
        platform
        url
      }
    }
  }
  departments {
    __typename
    departments {
      __typename
      title
      subtitle
      teamMember {
        __typename
        name
        slug
        role
        isResearcher
        description
        image
        socials {
          __typename
          platform
          url
        }
      }
    }
  }
  milestones {
    __typename
    title
    milestones {
      __typename
      title
      subtitle
      events
      button {
        __typename
        label
        link
      }
    }
  }
  investors {
    __typename
    localNote
    title
    subtitle
    includeLogos
  }
  awards {
    __typename
    title
    subtitle
    awards {
      __typename
      label
      logo
      link
    }
  }
  cta {
    __typename
    localNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
    noindex
    ogType
    image
    breadcrumbs {
      __typename
      label
      url
    }
  }
}
    `;
export const CommunityEditionPartsFragmentDoc = gql`
    fragment CommunityEditionParts on CommunityEdition {
  __typename
  header {
    __typename
    pretitle
    title
    subtitle
    benefits {
      __typename
      title
      description
    }
  }
  formSection {
    __typename
    portalId
    formGuid
    fallbackFormUrl
    successMessage
    successMessageSubtitle
    disclaimer
  }
  inActionSection {
    __typename
    title
    description
    iframeUrl
  }
  includedSection {
    __typename
    title
    subtitle
    sections {
      __typename
      title
      features {
        __typename
        name
      }
    }
  }
  cta {
    __typename
    localNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
    noindex
    ogType
    image
    breadcrumbs {
      __typename
      label
      url
    }
  }
}
    `;
export const BookDemoPartsFragmentDoc = gql`
    fragment BookDemoParts on BookDemo {
  __typename
  header {
    __typename
    pretitle
    title
    subtitle
    benefits {
      __typename
      title
      description
    }
  }
  formSection {
    __typename
    meetingLinkSlug
    fallbackFormUrl
    successMessage
    successMessageSubtitle
  }
  videoSection {
    __typename
    title
    description
    video {
      ... on Resources {
        __typename
        ... on ResourcesAdvisory {
          templateType
          published
          publishDate
          advisoryId
          cveId
          title
          subtitle
          cvssScore
          categories {
            __typename
          }
          tags {
            __typename
          }
          affectedVendors {
            __typename
            name
          }
          affectedProducts {
            __typename
            name
          }
          description
          vulnerabilityInformation
          potentialImpact
          details {
            __typename
            title
            content
          }
          _githubSource
          _githubSyncDate
          _readOnly
          headerCta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          cta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesArticle {
          templateType
          published
          publishDate
          title
          description
          headerBackgroundImage
          authors {
            __typename
            ... on ResourcesArticleAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesArticleAuthorsTeamAuthor {
              team
            }
            ... on ResourcesArticleAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesBlog {
          templateType
          published
          publishDate
          title
          description
          headerBackgroundImage
          authors {
            __typename
            ... on ResourcesBlogAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesBlogAuthorsTeamAuthor {
              team
            }
            ... on ResourcesBlogAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesStudy {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          header {
            __typename
            logo
            title
            graphic
            file
          }
          sections {
            __typename
            ... on ResourcesStudySectionsOpening {
              description
              quote
              author
              authorRole
            }
            ... on ResourcesStudySectionsChallenge {
              title
              subtitle
              challenges {
                __typename
                title
                description
              }
            }
            ... on ResourcesStudySectionsSolution {
              title
              subtitle
              solutions {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesStudySectionsResults {
              title
              subtitle
              results {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesStudySectionsConclusion {
              title
              description
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesNews {
          templateType
          published
          publishDate
          title
          description
          authors {
            __typename
            ... on ResourcesNewsAuthorsTeamMemberAuthor {
              slug
              cachedName
              cachedRole
            }
            ... on ResourcesNewsAuthorsTeamAuthor {
              team
            }
            ... on ResourcesNewsAuthorsCustomAuthor {
              name
              url
            }
          }
          author
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesPatent {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          content
        }
        ... on ResourcesPress {
          templateType
          published
          title
          publishDate
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesReport {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          uploadReport
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesTool {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          externalUrl
          logo
          hasDetailPage
          header {
            __typename
            title
            tagline
            buttons {
              __typename
              label
              link
            }
          }
          sections {
            __typename
            ... on ResourcesToolSectionsToolIntro {
              title
              subtitle
              problemItems {
                __typename
                title
                description
              }
              solutionItems {
                __typename
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolCapabilities {
              title
              subtitle
              capabilities {
                __typename
                title
                description
                tag
              }
            }
            ... on ResourcesToolSectionsToolSteps {
              title
              subtitle
              steps {
                __typename
                label
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolUseCases {
              title
              subtitle
              useCases {
                __typename
                icon
                title
                description
              }
            }
            ... on ResourcesToolSectionsToolResources {
              title
              resources {
                __typename
              }
            }
          }
          cta {
            __typename
            localNote
            title
            description
            buttons {
              __typename
              _breadcrumb
              label
              link
            }
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
        }
        ... on ResourcesVideo {
          templateType
          published
          publishDate
          title
          description
          categories {
            __typename
          }
          tags {
            __typename
          }
          resourceSeo {
            __typename
            seoTitle
            seoDescription
            keywords
            ogType
            image
            breadcrumbs {
              __typename
              label
              url
            }
          }
          url
        }
      }
      ... on Document {
        _sys {
          filename
          basename
          hasReferences
          breadcrumbs
          path
          relativePath
          extension
        }
        id
      }
    }
  }
  cta {
    __typename
    localNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
    noindex
    ogType
    image
    breadcrumbs {
      __typename
      label
      url
    }
  }
}
    `;
export const NewslettersPartsFragmentDoc = gql`
    fragment NewslettersParts on Newsletters {
  __typename
  header {
    __typename
    pretitle
    title
    subtitle
    button {
      __typename
      label
      link
    }
  }
  cta {
    __typename
    localNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
    noindex
    ogType
    image
    breadcrumbs {
      __typename
      label
      url
    }
  }
}
    `;
export const CommunityPartsFragmentDoc = gql`
    fragment CommunityParts on Community {
  __typename
  header {
    __typename
    pretitle
    title
    subtitle
    linkText
    linkUrl
  }
  formSection {
    __typename
    disclaimer
  }
  testimonials {
    __typename
    image
    quote
    name
    role
  }
  cta {
    __typename
    localNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
    noindex
    ogType
    image
    breadcrumbs {
      __typename
      label
      url
    }
  }
}
    `;
export const LegalAndCompliancePartsFragmentDoc = gql`
    fragment LegalAndComplianceParts on LegalAndCompliance {
  __typename
  header {
    __typename
    pretitle
    title
    subtitle
    button {
      __typename
      label
      link
    }
  }
  sections {
    __typename
    title
    description
  }
  cta {
    __typename
    localNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
    noindex
    ogType
    image
    breadcrumbs {
      __typename
      label
      url
    }
  }
}
    `;
export const GlobalPartsFragmentDoc = gql`
    fragment GlobalParts on Global {
  __typename
  navigation {
    __typename
    _breadcrumb
    navMenus {
      __typename
      ... on GlobalNavigationNavMenusSimpleList {
        _breadcrumb
        label
        title
        url
        menu {
          __typename
          _breadcrumb
          label
          url
        }
      }
      ... on GlobalNavigationNavMenusMultiMenu {
        _breadcrumb
        label
        title
        url
        description
        size
        subMenus {
          __typename
          _breadcrumb
          title
          links {
            __typename
            _breadcrumb
            label
            url
          }
        }
        footerMenu {
          __typename
          _breadcrumb
          title
          url
          description
        }
      }
    }
    navButtons {
      __typename
      _breadcrumb
      label
      url
    }
  }
  alert {
    __typename
    _breadcrumb
    enabled
    message
    expiryDate
    label
    link
  }
  footer {
    __typename
    _breadcrumb
    title
    primaryNavigationItems {
      __typename
      _breadcrumb
      title
      links {
        __typename
        _breadcrumb
        label
        url
      }
    }
    secondaryNavigation {
      __typename
      _breadcrumb
      label
      url
    }
    socials {
      __typename
      _breadcrumb
      platform
      url
    }
  }
  logos {
    __typename
    _breadcrumb
    title
    logos {
      __typename
      _breadcrumb
      image
      url
      altText
    }
  }
  testimonials {
    __typename
    _breadcrumb
    testimonials {
      __typename
      _breadcrumb
      image
      quote
      name
      role
    }
  }
  cta {
    __typename
    _breadcrumb
    globalNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  resourceCta {
    __typename
    _breadcrumb
    globalNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  advisoryHeaderCta {
    __typename
    _breadcrumb
    globalNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  advisoryCta {
    __typename
    _breadcrumb
    globalNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  solutionsHeader {
    __typename
    _breadcrumb
    globalNote
    video
    image
  }
  solutionsCta {
    __typename
    _breadcrumb
    globalNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  teamCta {
    __typename
    _breadcrumb
    globalNote
    title
    description
    buttons {
      __typename
      _breadcrumb
      label
      link
    }
  }
  shareDialog {
    __typename
    _breadcrumb
    title
    description
  }
  rssDialog {
    __typename
    _breadcrumb
    title
    description
  }
  subscribeForm {
    __typename
    _breadcrumb
    disclaimer
    successTitle
    successSubtitle
    buttonLabel
    placeholder
  }
  seo {
    __typename
    _breadcrumb
    title
    description
    keywords
    image
  }
  organization {
    __typename
    _breadcrumb
    legalName
    description
    logo
    foundingDate
    founders {
      __typename
      _breadcrumb
      name
      url
    }
    address {
      __typename
      streetAddress
      addressLocality
      addressRegion
      postalCode
      addressCountry
    }
    contact {
      __typename
      email
      telephone
      contactType
    }
    sameAs {
      __typename
      _breadcrumb
      url
    }
    twitterSite
    twitterCreatorDefault
  }
}
    `;
export const ResourcesDeepSearchDocument = gql`
    query resourcesDeepSearch($filter: ResourcesFilter, $sort: String, $last: Float) {
  resourcesConnection(filter: $filter, sort: $sort, last: $last) {
    edges {
      node {
        ... on Document {
          id
          _sys {
            filename
          }
        }
        __typename
        ... on ResourcesAdvisory {
          templateType
          published
          publishDate
          advisoryId
          cveId
          title
          cvssScore
          description
          vulnerabilityInformation
          potentialImpact
          details {
            title
            content
          }
          affectedVendors {
            name
          }
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesBlog {
          templateType
          published
          publishDate
          title
          description
          content
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesArticle {
          templateType
          published
          publishDate
          title
          description
          content
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesStudy {
          templateType
          published
          publishDate
          title
          description
          header {
            logo
          }
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesNews {
          templateType
          published
          publishDate
          title
          description
          content
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesPress {
          templateType
          published
          publishDate
          title
          description
          externalUrl
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesReport {
          templateType
          published
          publishDate
          title
          description
          externalUrl
          uploadReport
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesVideo {
          templateType
          published
          publishDate
          title
          description
          url
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesTool {
          templateType
          published
          publishDate
          title
          description
          externalUrl
          logo
          hasDetailPage
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesPatent {
          templateType
          published
          publishDate
          title
          description
          content
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const ResourcesListDocument = gql`
    query resourcesList($filter: ResourcesFilter, $sort: String, $last: Float) {
  resourcesConnection(filter: $filter, sort: $sort, last: $last) {
    edges {
      node {
        ... on Document {
          id
          _sys {
            filename
            path
          }
        }
        __typename
        ... on ResourcesAdvisory {
          templateType
          published
          publishDate
          advisoryId
          cveId
          title
          cvssScore
          description
          affectedVendors {
            name
          }
          affectedProducts {
            name
          }
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesBlog {
          templateType
          published
          publishDate
          title
          description
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesArticle {
          templateType
          published
          publishDate
          title
          description
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesStudy {
          templateType
          published
          publishDate
          title
          description
          header {
            logo
          }
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesNews {
          templateType
          published
          publishDate
          title
          description
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesPress {
          templateType
          published
          publishDate
          title
          description
          externalUrl
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesReport {
          templateType
          published
          publishDate
          title
          description
          externalUrl
          uploadReport
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesVideo {
          templateType
          published
          publishDate
          title
          description
          url
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesTool {
          templateType
          published
          publishDate
          title
          description
          externalUrl
          logo
          hasDetailPage
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
        ... on ResourcesPatent {
          templateType
          published
          publishDate
          title
          description
          categories {
            category {
              ... on CategoriesCategory {
                title
                categorySlug
              }
            }
          }
          tags {
            tag {
              ... on TagsTag {
                title
                tagSlug
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const ResourcesDocument = gql`
    query resources($relativePath: String!) {
  resources(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ResourcesParts
  }
}
    ${ResourcesPartsFragmentDoc}`;
export const ResourcesConnectionDocument = gql`
    query resourcesConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ResourcesFilter) {
  resourcesConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ResourcesParts
      }
    }
  }
}
    ${ResourcesPartsFragmentDoc}`;
export const ResourceLandingPagesDocument = gql`
    query resourceLandingPages($relativePath: String!) {
  resourceLandingPages(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ResourceLandingPagesParts
  }
}
    ${ResourceLandingPagesPartsFragmentDoc}`;
export const ResourceLandingPagesConnectionDocument = gql`
    query resourceLandingPagesConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ResourceLandingPagesFilter) {
  resourceLandingPagesConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ResourceLandingPagesParts
      }
    }
  }
}
    ${ResourceLandingPagesPartsFragmentDoc}`;
export const CategoriesDocument = gql`
    query categories($relativePath: String!) {
  categories(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...CategoriesParts
  }
}
    ${CategoriesPartsFragmentDoc}`;
export const CategoriesConnectionDocument = gql`
    query categoriesConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: CategoriesFilter) {
  categoriesConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...CategoriesParts
      }
    }
  }
}
    ${CategoriesPartsFragmentDoc}`;
export const TagsDocument = gql`
    query tags($relativePath: String!) {
  tags(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...TagsParts
  }
}
    ${TagsPartsFragmentDoc}`;
export const TagsConnectionDocument = gql`
    query tagsConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: TagsFilter) {
  tagsConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...TagsParts
      }
    }
  }
}
    ${TagsPartsFragmentDoc}`;
export const SolutionIndexPagesDocument = gql`
    query solutionIndexPages($relativePath: String!) {
  solutionIndexPages(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...SolutionIndexPagesParts
  }
}
    ${SolutionIndexPagesPartsFragmentDoc}`;
export const SolutionIndexPagesConnectionDocument = gql`
    query solutionIndexPagesConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: SolutionIndexPagesFilter) {
  solutionIndexPagesConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...SolutionIndexPagesParts
      }
    }
  }
}
    ${SolutionIndexPagesPartsFragmentDoc}`;
export const SolutionsDocument = gql`
    query solutions($relativePath: String!) {
  solutions(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...SolutionsParts
  }
}
    ${SolutionsPartsFragmentDoc}`;
export const SolutionsConnectionDocument = gql`
    query solutionsConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: SolutionsFilter) {
  solutionsConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...SolutionsParts
      }
    }
  }
}
    ${SolutionsPartsFragmentDoc}`;
export const ResearchPagesDocument = gql`
    query researchPages($relativePath: String!) {
  researchPages(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ResearchPagesParts
  }
}
    ${ResearchPagesPartsFragmentDoc}`;
export const ResearchPagesConnectionDocument = gql`
    query researchPagesConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ResearchPagesFilter) {
  researchPagesConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ResearchPagesParts
      }
    }
  }
}
    ${ResearchPagesPartsFragmentDoc}`;
export const ReportsDocument = gql`
    query reports($relativePath: String!) {
  reports(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ReportsParts
  }
}
    ${ReportsPartsFragmentDoc}`;
export const ReportsConnectionDocument = gql`
    query reportsConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ReportsFilter) {
  reportsConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ReportsParts
      }
    }
  }
}
    ${ReportsPartsFragmentDoc}`;
export const FormLandingPagesDocument = gql`
    query formLandingPages($relativePath: String!) {
  formLandingPages(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...FormLandingPagesParts
  }
}
    ${FormLandingPagesPartsFragmentDoc}`;
export const FormLandingPagesConnectionDocument = gql`
    query formLandingPagesConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: FormLandingPagesFilter) {
  formLandingPagesConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...FormLandingPagesParts
      }
    }
  }
}
    ${FormLandingPagesPartsFragmentDoc}`;
export const HomeDocument = gql`
    query home($relativePath: String!) {
  home(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...HomeParts
  }
}
    ${HomePartsFragmentDoc}`;
export const HomeConnectionDocument = gql`
    query homeConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: HomeFilter) {
  homeConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...HomeParts
      }
    }
  }
}
    ${HomePartsFragmentDoc}`;
export const FeaturesDocument = gql`
    query features($relativePath: String!) {
  features(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...FeaturesParts
  }
}
    ${FeaturesPartsFragmentDoc}`;
export const FeaturesConnectionDocument = gql`
    query featuresConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: FeaturesFilter) {
  featuresConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...FeaturesParts
      }
    }
  }
}
    ${FeaturesPartsFragmentDoc}`;
export const PackagesDocument = gql`
    query packages($relativePath: String!) {
  packages(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...PackagesParts
  }
}
    ${PackagesPartsFragmentDoc}`;
export const PackagesConnectionDocument = gql`
    query packagesConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: PackagesFilter) {
  packagesConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...PackagesParts
      }
    }
  }
}
    ${PackagesPartsFragmentDoc}`;
export const AboutDocument = gql`
    query about($relativePath: String!) {
  about(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...AboutParts
  }
}
    ${AboutPartsFragmentDoc}`;
export const AboutConnectionDocument = gql`
    query aboutConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: AboutFilter) {
  aboutConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...AboutParts
      }
    }
  }
}
    ${AboutPartsFragmentDoc}`;
export const CommunityEditionDocument = gql`
    query communityEdition($relativePath: String!) {
  communityEdition(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...CommunityEditionParts
  }
}
    ${CommunityEditionPartsFragmentDoc}`;
export const CommunityEditionConnectionDocument = gql`
    query communityEditionConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: CommunityEditionFilter) {
  communityEditionConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...CommunityEditionParts
      }
    }
  }
}
    ${CommunityEditionPartsFragmentDoc}`;
export const BookDemoDocument = gql`
    query bookDemo($relativePath: String!) {
  bookDemo(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...BookDemoParts
  }
}
    ${BookDemoPartsFragmentDoc}`;
export const BookDemoConnectionDocument = gql`
    query bookDemoConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: BookDemoFilter) {
  bookDemoConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...BookDemoParts
      }
    }
  }
}
    ${BookDemoPartsFragmentDoc}`;
export const NewslettersDocument = gql`
    query newsletters($relativePath: String!) {
  newsletters(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...NewslettersParts
  }
}
    ${NewslettersPartsFragmentDoc}`;
export const NewslettersConnectionDocument = gql`
    query newslettersConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: NewslettersFilter) {
  newslettersConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...NewslettersParts
      }
    }
  }
}
    ${NewslettersPartsFragmentDoc}`;
export const CommunityDocument = gql`
    query community($relativePath: String!) {
  community(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...CommunityParts
  }
}
    ${CommunityPartsFragmentDoc}`;
export const CommunityConnectionDocument = gql`
    query communityConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: CommunityFilter) {
  communityConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...CommunityParts
      }
    }
  }
}
    ${CommunityPartsFragmentDoc}`;
export const LegalAndComplianceDocument = gql`
    query legalAndCompliance($relativePath: String!) {
  legalAndCompliance(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...LegalAndComplianceParts
  }
}
    ${LegalAndCompliancePartsFragmentDoc}`;
export const LegalAndComplianceConnectionDocument = gql`
    query legalAndComplianceConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: LegalAndComplianceFilter) {
  legalAndComplianceConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...LegalAndComplianceParts
      }
    }
  }
}
    ${LegalAndCompliancePartsFragmentDoc}`;
export const GlobalDocument = gql`
    query global($relativePath: String!) {
  global(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...GlobalParts
  }
}
    ${GlobalPartsFragmentDoc}`;
export const GlobalConnectionDocument = gql`
    query globalConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: GlobalFilter) {
  globalConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...GlobalParts
      }
    }
  }
}
    ${GlobalPartsFragmentDoc}`;
export function getSdk(requester) {
  return {
    resourcesDeepSearch(variables, options) {
      return requester(ResourcesDeepSearchDocument, variables, options);
    },
    resourcesList(variables, options) {
      return requester(ResourcesListDocument, variables, options);
    },
    resources(variables, options) {
      return requester(ResourcesDocument, variables, options);
    },
    resourcesConnection(variables, options) {
      return requester(ResourcesConnectionDocument, variables, options);
    },
    resourceLandingPages(variables, options) {
      return requester(ResourceLandingPagesDocument, variables, options);
    },
    resourceLandingPagesConnection(variables, options) {
      return requester(ResourceLandingPagesConnectionDocument, variables, options);
    },
    categories(variables, options) {
      return requester(CategoriesDocument, variables, options);
    },
    categoriesConnection(variables, options) {
      return requester(CategoriesConnectionDocument, variables, options);
    },
    tags(variables, options) {
      return requester(TagsDocument, variables, options);
    },
    tagsConnection(variables, options) {
      return requester(TagsConnectionDocument, variables, options);
    },
    solutionIndexPages(variables, options) {
      return requester(SolutionIndexPagesDocument, variables, options);
    },
    solutionIndexPagesConnection(variables, options) {
      return requester(SolutionIndexPagesConnectionDocument, variables, options);
    },
    solutions(variables, options) {
      return requester(SolutionsDocument, variables, options);
    },
    solutionsConnection(variables, options) {
      return requester(SolutionsConnectionDocument, variables, options);
    },
    researchPages(variables, options) {
      return requester(ResearchPagesDocument, variables, options);
    },
    researchPagesConnection(variables, options) {
      return requester(ResearchPagesConnectionDocument, variables, options);
    },
    reports(variables, options) {
      return requester(ReportsDocument, variables, options);
    },
    reportsConnection(variables, options) {
      return requester(ReportsConnectionDocument, variables, options);
    },
    formLandingPages(variables, options) {
      return requester(FormLandingPagesDocument, variables, options);
    },
    formLandingPagesConnection(variables, options) {
      return requester(FormLandingPagesConnectionDocument, variables, options);
    },
    home(variables, options) {
      return requester(HomeDocument, variables, options);
    },
    homeConnection(variables, options) {
      return requester(HomeConnectionDocument, variables, options);
    },
    features(variables, options) {
      return requester(FeaturesDocument, variables, options);
    },
    featuresConnection(variables, options) {
      return requester(FeaturesConnectionDocument, variables, options);
    },
    packages(variables, options) {
      return requester(PackagesDocument, variables, options);
    },
    packagesConnection(variables, options) {
      return requester(PackagesConnectionDocument, variables, options);
    },
    about(variables, options) {
      return requester(AboutDocument, variables, options);
    },
    aboutConnection(variables, options) {
      return requester(AboutConnectionDocument, variables, options);
    },
    communityEdition(variables, options) {
      return requester(CommunityEditionDocument, variables, options);
    },
    communityEditionConnection(variables, options) {
      return requester(CommunityEditionConnectionDocument, variables, options);
    },
    bookDemo(variables, options) {
      return requester(BookDemoDocument, variables, options);
    },
    bookDemoConnection(variables, options) {
      return requester(BookDemoConnectionDocument, variables, options);
    },
    newsletters(variables, options) {
      return requester(NewslettersDocument, variables, options);
    },
    newslettersConnection(variables, options) {
      return requester(NewslettersConnectionDocument, variables, options);
    },
    community(variables, options) {
      return requester(CommunityDocument, variables, options);
    },
    communityConnection(variables, options) {
      return requester(CommunityConnectionDocument, variables, options);
    },
    legalAndCompliance(variables, options) {
      return requester(LegalAndComplianceDocument, variables, options);
    },
    legalAndComplianceConnection(variables, options) {
      return requester(LegalAndComplianceConnectionDocument, variables, options);
    },
    global(variables, options) {
      return requester(GlobalDocument, variables, options);
    },
    globalConnection(variables, options) {
      return requester(GlobalConnectionDocument, variables, options);
    }
  };
}
import { createClient } from "tinacms/dist/client";
const generateRequester = (client) => {
  const requester = async (doc, vars, options) => {
    let url = client.apiUrl;
    if (options?.branch) {
      const index = client.apiUrl.lastIndexOf("/");
      url = client.apiUrl.substring(0, index + 1) + options.branch;
    }
    const data = await client.request({
      query: doc,
      variables: vars,
      url
    }, options);
    return { data: data?.data, errors: data?.errors, query: doc, variables: vars || {} };
  };
  return requester;
};
export const ExperimentalGetTinaClient = () => getSdk(
  generateRequester(
    createClient({
      url: "https://content.tinajs.io/3.0/content/175bff9f-3302-450a-a51e-b7751ad5397c/github/main",
      queries
    })
  )
);
export const queries = (client) => {
  const requester = generateRequester(client);
  return getSdk(requester);
};
